export const theme = {
  'token': {
    'colorPrimary': '#da2128',
    'fontSize': 16,
    'borderRadius': 11,
    'wireframe': false,
    // 'fontFamily': 'Noto Sans',
  }
}